export default {
    'total-bonds': 'عدد السندات الكلي',
    'file-state': 'حالة الملف',
    'financial-file-fund': 'حساب الصندوق الرئيسي',
    'undefined': ' غير محدد يرجى تعيين حساب.',
    'not-posted': 'الغير مُرحّلة',
    'all-posted-bonds': 'جميع السندات مُرحلة',
    'locked': 'مُقفل',
    'unlocked': 'غير مُقفل',
    'pin-account': "تثبيت حساب",
    'unpin-account': "إلغاء تثبيت",
    "pinned-accounts": "الحسابات المثبتة" 
}